export const waterCounterInitialState = {
  gallonsSaved: ['0', '0', '0', '0', '0'],
  daysSince: 0,
};
